import styled from "styled-components"

export default styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`

export const Wrapper = styled.div`
  flex-grow: 1;
`
